export interface IUserInfoModel {
    id: number,
    username: string,
    full_name: string,
    token_version: string,
    menus: IMenuModel[],
    apis: IApiModel[],
    campus: ICampusModel[],
    sub_systems: IUserSubSystemModel[],
    roles: IRoleModel[]

}
export interface IMenuModel {
    id: number;
    name: string;
    path: string;
    icon: string;
    menu_parent_id: number;
    is_active: boolean;
    items: IMenuModel[];
    alert_number: number;
    expanded: boolean;
    menu_id: number;
}
export interface IApiModel {
    id: number;
    url: string;
}
export interface ICampusModel {
    id: number;
    ma_truong: string;
    ten_truong: string;
    viet_tat: string;
    dm_coso_id: number;
    dm_coso_viettat: string;
}
export interface IRoleModel {
    id: number;
    name: string;
}
export interface IUserSubSystemModel {
    id: number;
    name: string;
    name_en: string;
    icon: string;
    url: string;
    is_accessed: boolean;
}
export const initialUserInfo: IUserInfoModel = {
    apis: [],
    campus: [],
    full_name: "",
    id: 0,
    menus: [],
    roles: [],
    sub_systems: [],
    username: "",
    token_version: ""
}